import React from 'react';
import { NavItem, NavLink } from 'reactstrap';
// import MaterialIcon from 'material-icons-react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';


const SysControlSideMenuListItem = props => {
    const { navItemStyle, navLinkStyle } = styles;

    const locationSections = props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");
    const selectedSection = locationSections.slice(-1)[0];

    return (

        <NavItem>
            <NavLink
                id={props.item.name}
                className={classnames({ active: selectedSection === `${props.item.name}` })}
                tag={Link} to={`/system-control/${props.item.name}`}
                style={navLinkStyle}>
                <div style={navItemStyle}>
                    {/* <MaterialIcon icon={props.item.icon} size={20} color="#000" /> */}
                    <span style={{ paddingLeft: 4 }}>{props.item.translation}</span>
                </div>
            </NavLink>
        </NavItem>
    );
}

export default SysControlSideMenuListItem;

const styles = {
    navItemStyle: {
        fontSize: 14,
        paddingTop: 10,
        paddingRight: 15,
        paddingBottom: 10,
        paddingLeft: 15,
        borderBottom: '1px solid #d9d9d9',
        transition: 'border-bottom 0.75s',
        flexDirection: 'column',
        cursor: 'pointer'
    },
    navLinkStyle: {
        padding: 0,
        width: '100%'
    }
}


// WEBPACK FOOTER //
// ./src/components/systemControl/SysControlSideMenuListItem.js